import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

export const PURCHASE_STEPS = ['Alege planul', 'Date si plata', 'Confirmare'];

/** Indicator de progres: cercuri numerotate legate prin linii; `current` este indexul pasului activ. */
const PremiumSteps = ({ steps = PURCHASE_STEPS, current = 0 }) => (
  <ol className="pm-steps" aria-label="Pașii achiziției">
    {steps.map((label, index) => {
      const state = index < current ? 'done' : index === current ? 'active' : 'todo';
      return (
        <li
          key={label}
          className={`pm-step pm-step--${state}`}
          aria-current={state === 'active' ? 'step' : undefined}
        >
          <span className="pm-step-dot" aria-hidden="true">
            {state === 'done' ? <FontAwesomeIcon icon={faCheck} /> : index + 1}
          </span>
          <span className="pm-step-label">{label}</span>
        </li>
      );
    })}
  </ol>
);

export default PremiumSteps;
